module.exports = __webpack_public_path__ + "static/media/book-who-is-nemos-detail1.c334c851.jpg";